<input type="password" class="form-control form-control-lg" [(ngModel)]="token" (keyup.enter)="login()" placeholder="Passwort" required>
